import React from 'react';

const WorkshopHeader = ({ attendeeName, workshopCount, onBackToEvents, onLogout }) => {
  return (
    <div className="wk-header-wrap">
      <div className="wk-header-top">
        <span className="ep-live-badge">
          <span className="ep-pulse-dot" />
          Attendee workspace
        </span>

        <div className="wk-user-panel">
          <span className="wk-user-name">{attendeeName}</span>
          <button
            type="button"
            className="ep-btn-ghost wk-logout-btn"
            onClick={onLogout}
            aria-label="Log out"
          >
            Logout
          </button>
        </div>
      </div>

      <h1 className="ep-hero-title wk-title">Welcome, {attendeeName}</h1>
      <p className="ep-hero-sub wk-sub">
        {workshopCount > 0
          ? `You have ${workshopCount} assigned workshop${workshopCount > 1 ? 's' : ''}.`
          : 'No workshops assigned yet. Browse upcoming events to get started.'}
      </p>
    </div>
  );
};

export default WorkshopHeader;
